import React from 'react'
import PropTypes from 'prop-types'
import ModalWrapper from './components/ModalWrapper'
import InlineWrapper from './components/InlineWrapper'

const AptitudeInstructionBar = ({ page, factor }) => {
  if (page === 1) {
    return <InlineWrapper factor={factor} />
  }
  return <ModalWrapper factor={factor} />
}

AptitudeInstructionBar.propTypes = {
  page: PropTypes.number.isRequired,
  factor: PropTypes.string.isRequired,
}

export default AptitudeInstructionBar
